import { ApiService } from '@/api/services/core/ApiService';
import { axiosInstance } from '@/api/axios';

const environmentMapping = {
  stage: process.env.VUE_APP_API_RECEIPT_VIEW_STAGE,
  development: process.env.VUE_APP_API_RECEIPT_VIEW_DEVELOPMENT,
  production: process.env.VUE_APP_API_RECEIPT_VIEW_PRODUCTION,
};

export const getBaseReceiptUrl =
  environmentMapping[
    (process.env.VUE_APP_ENVIRONMENT as keyof typeof environmentMapping) ||
      'development'
  ] + 'api/external/';
export const getReceiptUrl = (mid?: string | number) => `receipts/png/${mid}`;

// TODO: Add config.js for URL ext service
export class ReceiptImageService extends ApiService {
  public getReceiptImage(mid: string | number) {
    return axiosInstance.get<any>(getReceiptUrl(mid), {
      responseType: 'blob',
    });
  }
}
